import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import PlanBuilder from './components/PlanBuilder';
import TestRunner from './components/TestRunner';
import Dashboard from './components/Dashboard';
import ResultsEditor from './components/ResultsEditor';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/builder" element={<PlanBuilder />} />
            <Route path="/builder/:id" element={<PlanBuilder />} />
            <Route path="/plan/:id" element={<TestRunner />} />
            <Route path="/dashboard/:id" element={<Dashboard />} />
            <Route path="/results-editor/:id" element={<ResultsEditor />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App; 